import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from '@mui/material';

import { VideaTypography } from '../../common-components/elements/VideaTypography/VideaTypography';

import { Flex, SubCard, TipsAndUpdatesOutlinedIcon } from './CommonStyles';

const HowToShowHideFindings = styled.img`
  width: 17em;
  border-radius: 0.5em;
`;

export const HowToCard = () => {
  return (
    <SubCard data-testid="sub-card">
      <Flex className="center">
        <div>
          <VideaTypography variant="bodyExtrasmall">
            <Trans>
              How to Show/Hide Individual Findings <a href="/">Link</a>
            </Trans>
          </VideaTypography>
          <HowToShowHideFindings
            src="/assets/images/ddai/howToShowHideFindings.png"
            alt=""
          />
        </div>
        <Divider orientation="vertical" />
        <Flex className="column left-margin">
          <Flex className="align-center">
            <VideaTypography variant="labelSmallStrong">
              <Trans>FAQs</Trans>
            </VideaTypography>
            <TipsAndUpdatesOutlinedIcon />
          </Flex>
          <div>
            <Accordion>
              <AccordionSummary>
                <VideaTypography variant="labelSmallStrong">
                  <Trans>How accurate is the AI? </Trans>
                </VideaTypography>
              </AccordionSummary>
              <AccordionDetails>
                <VideaTypography variant="bodyExtrasmall">
                  <Trans>
                    Dentistry&apos;s subjectivity makes pinpointing accuracy
                    challenging. However, our FDA study found a 31% average
                    increase in carious lesion detection, 100% clinical
                    improvement in disease detection, and a 15% reduction in
                    erroneous detections.{' '}
                  </Trans>
                </VideaTypography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary>
                <VideaTypography variant="labelSmallStrong">
                  <Trans>Does the AI learn in real-time? </Trans>
                </VideaTypography>
              </AccordionSummary>
              <AccordionDetails>
                <VideaTypography variant="bodyExtrasmall">
                  <Trans>
                    Dentrix Detect AI doesn&apos;t learn in real time. Yet,
                    incremental model updates over time enhance accuracy and
                    effectiveness.
                  </Trans>
                </VideaTypography>
              </AccordionDetails>
            </Accordion>
          </div>
          <VideaTypography variant="bodyExtrasmall">
            <Trans>
              We&apos;d love to hear from you! Send us your feedback at{' '}
              <a href="mailto:feedback@videa.ai">feedback@videa.ai</a>
            </Trans>
          </VideaTypography>
        </Flex>
      </Flex>
    </SubCard>
  );
};
